import { render, staticRenderFns } from "./RejectCommentsModal.vue?vue&type=template&id=a3b98634&scoped=true"
import script from "./RejectCommentsModal.vue?vue&type=script&lang=js"
export * from "./RejectCommentsModal.vue?vue&type=script&lang=js"
import style0 from "./RejectCommentsModal.vue?vue&type=style&index=0&id=a3b98634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3b98634",
  null
  
)

export default component.exports